import { PAGE_FIELDS_FRAGMENT } from '../Pages/fragments'

export const GET_DRAFT = gql`
  query GetDraft($id: String!, $workspaceId: String!) {
    workspaceDraft(id: $id, workspaceId: $workspaceId) {
      id
      workspaceId
      channel
      type
      scheduledSendTime
      status
      email {
        bcc
        cc
        from
        to
        subject
        replyToRfcId
      }
      parent {
        objectType
        objectId
        workspaceId
      }
      page {
        ...PageFields
      }
      createdAt
      updatedAt
    }
  }
  ${PAGE_FIELDS_FRAGMENT}
`

export const GET_DRAFTS_FOR_PARENT = gql`
  query GetDraftsForParent(
    $parentObjectReference: String!
    $workspaceId: String!
  ) {
    draftsForParentObject(
      parentObjectReference: $parentObjectReference
      workspaceId: $workspaceId
    ) {
      id
      workspaceId
      channel
      updatedAt
      createdAt
      email {
        subject
      }
    }
  }
`
